import '@banno/jha-wc/src/icons/jha-icon-information';
import '@banno/jha-wc/src/jha-tooltip/jha-tooltip.js';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

const credentialStateHelpText = {
    1: 'The credential is not registered.',
    2: 'The credential is in use.',
    3: 'The credential is in use with an associated account, but is not currently available. This state is set voluntarily, such as when a credential is lost or stolen. Temporary security codes are allowed.',
    4: 'The system has locked the token after the user entered multiple consecutive incorrect security codes.',
    5: 'The credential is in use with an associated account but is not currently available. This state does not permit the use of temporary security codes. This state also stops billing.',
};

export enum SymantecCredentialStateType {
    New = 1,
    Enabled = 2,
    Disabled = 3,
    Locked = 4,
    Inactive = 5,
}

@customElement('tm-bo-symantec-credential-state')
export class SymantecCredentialState extends TmBaseComponent {
    @property({ type: String })
    public status?: SymantecCredentialStateType;

    public render() {
        return html`
            <div class="flex items-center">
                <label class="mr-3">
                    Credential State:<jha-tooltip bottom .text=${this.credentialStateHelpText}>
                        <jha-icon-information class="cursor-pointer w-3 p-0"></jha-icon-information>
                    </jha-tooltip>
                </label>
                <div>
                    <span class="bold">${this.credentialState}</span>
                </div>
            </div>
        `;
    }

    private get credentialState() {
        const credentialState = this.status;
        if (credentialState === undefined) {
            return 'Unknown';
        }

        // get the text from the enum based on the number value
        return SymantecCredentialStateType[credentialState];
    }

    private get credentialStateHelpText() {
        if (!this.status) {
            return '';
        }
        const helpText = credentialStateHelpText[this.status];
        if (helpText === undefined) {
            return 'The credential state is unknown.';
        }

        return helpText;
    }
}
